<template>
    <modal
        :title="title"
        :id="id"
        :actionButtons="false"
        size="full"
        :closeButton="true"
        @shown="shown"
        @hidden="hidden"
    >
        <template slot="modal-header">
            <span></span>
        </template>
        <div id="printContent" v-if="customer && company">
            <div class="table-responsive">
                <table class="table table-bordered health-card-table">
                    <thead style="visibility: collapse;" class="never-print">
                    <tr>
                        <th class="border-0" scope="col" style="width: 8.33%"></th>
                        <th class="border-0" scope="col" style="width: 8.33%"></th>
                        <th class="border-0" scope="col" style="width: 8.33%"></th>
                        <th class="border-0" scope="col" style="width: 8.33%"></th>
                        <th class="border-0" scope="col" style="width: 8.33%"></th>
                        <th class="border-0" scope="col" style="width: 8.33%"></th>
                        <th class="border-0" scope="col" style="width: 8.33%"></th>
                        <th class="border-0" scope="col" style="width: 8.33%"></th>
                        <th class="border-0" scope="col" style="width: 8.33%"></th>
                        <th class="border-0" scope="col" style="width: 8.33%"></th>
                        <th class="border-0" scope="col" style="width: 8.33%"></th>
                        <th class="border-0" scope="col" style="width: 8.33%"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td colspan="12" class="border-0 p-0" style="border-bottom: 0!important; border-left: 0!important; border-right: 0!important;">
                            <company-print-header></company-print-header>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="12" class="text-center border-0" style="border-top: 0!important; border-left: 0!important; border-right: 0!important;">
                            <h1>{{$t('Patient health card')}}</h1>
                            <div class="h2">
                                <b>
                                    <span class="ml-2">{{ customer.first_name }} {{ customer.last_name }} {{customer.middle_name}}!</span>
                                </b>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="12">
                            {{$t('The information you provide will allow the doctor to choose effective anesthesia, medications and methods of treatment, and correctly draw up a treatment plan. The doctor will explain (in justified cases): whether there is a connection between your general health and the state of the oral cavity.')}}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="12">
                            {{$t('Your data is a medical secret and will not be available to unauthorized persons.')}}
                        </td>
                    </tr>
                    <tr>
                        <th colspan="8">{{$t('Last visit to a hospital or clinic (month, year):')}}</th>
                        <td colspan="4"></td>
                    </tr>
                    <tr>
                        <th colspan="8">{{$t('What was the appeal about?')}}</th>
                        <td colspan="4"></td>
                    </tr>
                    <tr>
                        <th colspan="8">
                            {{$t('Are you registered in a psycho-neurological, narcological, dermatological and venereal dispensary?')}}
                        </th>
                        <td colspan="4"></td>
                    </tr>
                    <tr>
                        <th colspan="8">{{$t('If yes, in what and from what time?')}}</th>
                        <td colspan="4"></td>
                    </tr>

                    <template v-for="(section, sectionIndex) in otherFields">
                        <tr>
                            <th scope="row" class="text-center" colspan="12">{{ section.label }}</th>
                        </tr>
                        <tr v-for="(field, fieldIndex) in section.fields" :key="fieldIndex">
                            <td colspan="6">{{ field.label }}</td>
                            <td colspan="6" class="text-center">
                                <div class="d-flex" v-if="customer.details && customer.details[field.name]">
                                    <button class="btn btn-white py-1">{{customer.details[field.name]}}</button>
                                </div>
                            </td>
                        </tr>
                    </template>

                    <tr>
                        <td colspan="12">{{$t('In addition, I want to inform you about the state of my health the following:')}}</td>
                    </tr>
                    <tr>
                        <td colspan="12"></td>
                    </tr>
                    <tr>
                        <td colspan="12"></td>
                    </tr>
                    <tr>
                        <td colspan="12"></td>
                    </tr>
                    <tr>
                        <td colspan="12">
                            Мои ответы на пункты анкеты были правдивыми.
                            <br/>Мне известно, что от состояния моего здоровья зависят:
                            <ul>
                                <li>Результаты лечения;</li>
                                <li>Гарантия на каждую работу, выполненную врачом;</li>
                            </ul>
                            <p>Я знаю:</p>
                            <ul>
                                <li>Что в случае приема лекарственных препаратов перед посещением стоматолога мне надо
                                    сообщить ему об этом;
                                </li>
                                <li>Что анкету о здоровье надо заполнять вновь каждые полгода;</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="12" class="border-0">
                            {{$t('Patient')}}:
                            <b>{{ customer.first_name }} {{ customer.last_name }}</b>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="6" class="border-0 text-capitalize">{{$t('signature')}}:</td>
                        <td colspan="6" class="text-right border-0">{{ today }}</td>
                    </tr>
                    </tbody>
                </table>
        </div>
        </div>
        <template slot="modal-footer">
            <div class="row d-none">
                <div class="col-12 col-lg-10 col-xl-8 p-5 text-muted border-top">Document generated by MyClient.uz</div>
            </div>
            <div class="card-footer invoiceFooter" style="display:block">
                <div class="row">
                    <div class="col"></div>
                    <div class="col-auto">
                        <button type="button" class="btn btn-white mr-2" @click="print()">
                            <i class="fe fe-printer"></i>
                            {{ $t('Print') }}
                        </button>
                        <button type="button" @click="close" class="btn btn-white">
                            {{ $t('Close') }}
                        </button>
                    </div>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import {mapActions, mapGetters, mapState} from 'vuex';
import {modalMixins} from '@/mixins/modal.js'
import CompanyPrintHeader from '@/components/Company/CompanyPrintHeader.vue';

export default {
    name: 'print-options',
    props: ['id', 'saveAction', 'data', 'customerId'],
    mixins: [modalMixins],
    components: {
        Modal,
        CompanyPrintHeader,
    },
    data() {
        return {
            title: 'Print options',
            today: this.$moment().format('MMMM DD, YYYY')
        }
    },
    computed: {
        ...mapGetters('customers', {
            getCustomerFromStore: 'get'
        }),
        ...mapGetters('my-company', {
            getCompanyFromStore: 'get'
        }),

        company() {
            return this.getCompanyFromStore("mine");
        },
        otherFields() {
            let sections = [];
            this.company.fields.forEach(section => {
                if (section.location.indexOf('healthcard') >= 0) sections.push(section);
            });
            return sections;
        },
        customer() {
            return this.getCustomerFromStore(this.customerId);
        },


    },

    methods: {
        hidden() {
            var $printSection = document.getElementById("printSection");
            if ($printSection) {
                $printSection.remove();
            }
        },
        shown() {
            this.print();
        },
        print() {
            var domClone = document.getElementById("printContent").cloneNode(true);

            var $printSection = document.getElementById("printSection");
            if (!$printSection) {
                var $printSection = document.createElement("div");
                $printSection.id = "printSection";
                document.body.appendChild($printSection);
            }

            $printSection.innerHTML = "";
            $printSection.appendChild(domClone);
            window.print();
        },
        close() {
            this.$root.$emit('bv::hide::modal', this.id);
        },


    },

}
</script>
<style lang="scss">

@media screen {
    #printContent {
        max-height: calc(var(--calculated-vh, 1vh) * 100 - 130px);
        overflow-y: auto;
        max-width: 100%;
    }
}

@media print {
    #printContent {
        .health-card-table {
            thead {
                border: none!important;
                tr {
                    border: none!important;
                    th {
                        height: 0!important;
                        background-color: #fff !important;
                        color: #fff !important;
                        border: none!important;
                    }
                    td {
                        border: none!important;
                    }
                }
            }
            tbody {
                td {
                    padding: .6rem;
                    border-top-color: #fff!important;
                    font-size: 16px;
                    b {
                        font-size: 18px;
                    }
                }
            }
        }
    }
}

</style>

